import { Injectable, signal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private counters = signal<Record<string, number>>({});

  loading = computed(() => Object.values(this.counters()).some((c) => c > 0));

  isLoading(key: string) {
    return computed(() => (this.counters()[key] ?? 0) > 0);
  }

  show(key = 'global') {
    this.counters.update((c) => ({ ...c, [key]: (c[key] ?? 0) + 1 }));
  }

  hide(key = 'global') {
    this.counters.update((c) => ({ ...c, [key]: Math.max((c[key] ?? 0) - 1, 0) }));
  }

  wrap<T>(promise: Promise<T>, key = 'global'): Promise<T> {
    this.show(key);
    return promise.finally(() => this.hide(key));
  }
}
